import { useEffect, useState } from "react";
import { getSupabaseClient } from "../providers/supabase/supabase";

// Plays a private call-recording / voicemail. activities.recording_url is stored as
// "call-recordings/<path>"; we strip the bucket prefix and mint a short-lived signed
// URL from the private bucket. Used by the lead activity log + the Voicemails list.
export function RecordingPlayer({ recordingUrl }: { recordingUrl: string }) {
  const [url, setUrl] = useState<string | null>(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let alive = true;
    const path = recordingUrl.replace(/^call-recordings\//, "");
    getSupabaseClient().storage.from("call-recordings").createSignedUrl(path, 3600)
      .then(({ data, error }) => {
        if (!alive) return;
        if (error || !data?.signedUrl) setErr(true);
        else setUrl(data.signedUrl);
      });
    return () => { alive = false; };
  }, [recordingUrl]);
  if (err) return <span className="text-xs text-muted-foreground">recording unavailable</span>;
  if (!url) return <span className="text-xs text-muted-foreground">loading audio…</span>;
  return <audio controls preload="none" src={url} className="h-8 w-full max-w-xs" />;
}
